// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609230904/js/" + chunkId + "." + {"44":"396f5e09","225":"519778ae","481":"24f6fedd","486":"c4a26db3","770":"e472514f"}[chunkId] + ".0.009974543819780468.chunk.js";
};